import {
  BluePencil,
  PlayRed,
  Reload,
  WhatsIcon,
  spaikIcon,
  whatsapp,
  whatsappActive
} from "./../../../../../assets/index";
import { Checkbox } from "primereact/checkbox";
import { RefObject, useEffect, useRef, useState } from "react";
import { css } from "@emotion/react";
import {
  ButtonReload,
  ButtonReloadDiv,
  CheckCard,
  ContainerLeftModal,
  ContainerQRCode,
  ContainerRightModal,
  ContainerTab,
  HiddenDiv,
  IconButton,
  Label,
  PhoneConected,
  RemoverButton,
  Span,
  Strong,
  Switch,
  ContainerButtons
} from "./styles";
import { Text } from "../../../../../components/Text";
import DialogPadrao from "../../../../../components/DialogPadrao";
import { ChatbotScript } from "../../ChatbotScript";
import { useAppSelector } from "../../../../../redux/hooks";
import { RightContentChatBotModal } from "../../chatBotModal/RightContent";
import { RightContentWhatsappModal } from "../../whatsappModal/RightContent";
import { LeftContentWhatsappModal } from "../../whatsappModal/LeftContent";
import { Toast } from "primereact/toast";
import { TabPanel, TabView } from "primereact/tabview";
import BotsServices from "../../../../../services/bots";
import { InputText } from "primereact/inputtext";
import { useToast } from "../../../../../components/toast-provider";
import { useAppDispatch } from "../../../../../redux/hooks";
import { setModalFbLoginOpen } from "../../../../../redux/slices/flowInteractions";
import { InputSwitch } from "primereact/inputswitch";
import { Button } from "primereact/button";
import { AuthContextType, useAuth } from "../../../../../auth/auth-provider";
import { IoMdPlayCircle } from "react-icons/io";
import { ProgressSpinner } from "primereact/progressspinner";
import Portal from "../../../../../components/portal";

const WHATSAPP_REMOVE_WAIT_MS = 15000;

interface Qrcode {
  url: string;
}
interface Webhook {
  enabled: string;
  webhookUrl: string;
}
interface Browser {
  browser: string;
  platform: string;
  version: string;
}
interface IWhatsappInstance {
  browser: Browser;
  error: string;
  key: string;
  message: string;
  qrcode: Qrcode;
  webhook: Webhook;
}

interface IChannelName {
  name: string;
  img: string;
  checked: boolean;
  toastRef?: RefObject<Toast>;
  channelType?: string;
}
interface IWhatsappInstanceInfo {
  qrCodeConnected: boolean;
  name: string;
  phone: string;
  keepBotOnDialogInitiatedOnDevice: boolean;
}
interface IWhatsappImage {
  error: string;
  message: string;
  qrcode: string;
}
export const ChannelCheck: React.FC<IChannelName> = ({
  name,
  img,
  checked,
  channelType
}) => {
  // const [checked, setChecked] = useState<boolean>(false);
  const {
    GetWhatsappInstance,
    GetWhatsappInstanceInfo,
    UpdateWhatsappInfo,
    LogoutWhatsappInstance,
    GetWhatsappImage
  } = BotsServices();
  const bot = useAppSelector((state) => state.bot);
  const toast = useToast();

  const dispatch = useAppDispatch();
  const [typeModal, setTypeModal] = useState("FACEBOOK");
  const openModalFb = (type: string) => {
    setTypeModal(type);
    dispatch(setModalFbLoginOpen(true));
  };
  const openModalInstagram = (type: string) => {
    setTypeModal(type);
    dispatch(setModalFbLoginOpen(true));
  };

  const [whatsappInstance, setWhatsappInstance] = useState<IWhatsappInstance>(
    {} as IWhatsappInstance
  );
  const [whatsappInstanceInfo, setWhatsappInstanceInfo] =
    useState<IWhatsappInstanceInfo>({
      name: "",
      phone: "",
      keepBotOnDialogInitiatedOnDevice: false,
      qrCodeConnected: false
    });
  const [rotateIconComponent, setRotateIconComponent] = useState(false);
  const [removingWhatsapp, setRemovingWhatsapp] = useState(false);
  const removeTimerRef = useRef<ReturnType<typeof setTimeout>>();
  const { user } = useAuth() as AuthContextType;
  const [displayModal, setDisplayModal] = useState(false);
  const [whatsappImage, setWhatsappImage] = useState<IWhatsappImage | null>({
    error: "",
    message: "",
    qrcode: ""
  });
  const botToken = useAppSelector(
    (state) => state.flowInteractions.tokenActive
  );
  const whatsappQrcode = useAppSelector((state) => state.bot.whatsappQrcode);
  const whatsappApiMeta = useAppSelector((state) => state.bot.whatsappApiMeta);
  const livechat = useAppSelector((state) => state.bot.livechat);
  const facebook = useAppSelector((state) => state.bot.facebook);
  const instagram = useAppSelector((state) => state.bot.instagram);
  const [activeIndex, setActiveIndex] = useState(() => {
    if (!whatsappQrcode && whatsappApiMeta) return 1;
    return 0;
  });

  const sleep = async (ms: number) => {
    // eslint-disable-next-line no-new
    return new Promise((resolve) => {
      setTimeout(resolve, ms);
    });
  };
  const getWhatsappImage = async () => {
    const imagem = await GetWhatsappImage(bot.id);
    setWhatsappImage(imagem);
    setRotateIconComponent(false);
  };
  const getWhatsappInstance = async () => {
    await GetWhatsappInstance(bot.id)
      .then(async (res) => {
        setWhatsappInstance(res);
        await sleep(2000);
        getWhatsappImage();
      })
      .catch(() => {
        toast?.current?.show({
          life: 5000,
          severity: "error",
          summary: "Erro",
          detail: "Erro ao buscar dados. Por favor tente mais tarde!"
        });
      });
  };

  const getWhatsappInstanceInfo = async () => {
    if (bot.id > 0) {
      await GetWhatsappInstanceInfo(bot.id)
        .then((res) => {
          setWhatsappInstanceInfo({
            name: res.name,
            phone: res.phone,
            keepBotOnDialogInitiatedOnDevice:
              res.keepBotOnDialogInitiatedOnDevice,
            qrCodeConnected: res.qrCodeConnected
          });
          setWhatsappImage(null);
        })
        .catch(() => {
          toast?.current?.show({
            life: 5000,
            severity: "error",
            summary: "Erro",
            detail: "Erro ao buscar dados. Por favor tente mais tarde!"
          });
        });
    }
  };

  useEffect(() => {
    return () => clearTimeout(removeTimerRef.current);
  }, []);

  const handleRemover = () => {
    setRemovingWhatsapp(true);

    LogoutWhatsappInstance(bot.id).catch(() => {
      toast?.current?.show({
        life: 5000,
        severity: "error",
        summary: "Erro",
        detail: "Erro ao remover. Por favor tente mais tarde!"
      });
    });

    removeTimerRef.current = setTimeout(() => {
      setRemovingWhatsapp(false);
      getWhatsappInstanceInfo();
      setWhatsappInstance({} as IWhatsappInstance);
      setWhatsappImage(null);
    }, WHATSAPP_REMOVE_WAIT_MS);
  };

  const setValue = (e: string) => {
    setWhatsappInstanceInfo({
      ...whatsappInstanceInfo,
      name: e
    });
  };

  const setValueSwitch = (e: boolean) => {
    setWhatsappInstanceInfo({
      ...whatsappInstanceInfo,
      keepBotOnDialogInitiatedOnDevice: e
    });
  };

  useEffect(() => {
    if (displayModal) {
      getWhatsappInstanceInfo();
    }
  }, [bot.id, displayModal]);

  const handleRotateIcon = async () => {
    setRotateIconComponent(true);
    getWhatsappInstance();

    setTimeout(() => {
      setRotateIconComponent(false);
      setWhatsappImage({
        error: "",
        message: "",
        qrcode: ""
      });
    }, 60000);
  };

  const handleCheckedIcon = (channelType: string | undefined) => {
    if (user.admin) {
      if (channelType === "INSTAGRAM") {
        openModalInstagram("INSTAGRAM");
      } else if (channelType === "FACEBOOK") {
        openModalFb("FACEBOOK");
      } else if (channelType === "WHATSAPP") {
        setDisplayModal(true);
      }
      return;
    }

    if (channelType === "INSTAGRAM" && instagram) {
      openModalInstagram("INSTAGRAM");
    } else if (channelType === "FACEBOOK" && facebook) {
      openModalFb("FACEBOOK");
    } else if (
      (channelType === "WHATSAPP" && whatsappQrcode) ||
      (channelType === "WHATSAPP" && whatsappApiMeta)
    ) {
      setDisplayModal(true);
    }
  };

  const handleUpdateChanges = async () => {
    const data = {
      name: whatsappInstanceInfo.name,
      keepBotOnDialogInitiatedOnDevice:
        whatsappInstanceInfo.keepBotOnDialogInitiatedOnDevice
    };
    try {
      await UpdateWhatsappInfo(bot.id, data);
      toast.current?.show({
        life: 5000,
        severity: "success",
        summary: "Sucesso",
        detail: "As informações foram atualizadas com sucesso."
      });
    } catch (error) {
      toast.current?.show({
        life: 5000,
        severity: "error",
        summary: "Erro",
        detail: "Erro ao atualizar. Por favor tente mais tarde!"
      });
    }
  };

  let lastToastTime = 0;
  const showSingleToast = (message: string) => {
    const now = Date.now();
    if (now - lastToastTime < 1000) return;
    lastToastTime = now;

    toast.current?.show({
      severity: "warn",
      summary: "Atenção",
      detail: message,
      life: 3000
    });
  };

  const handleShowWhatsappModal = () => {
    if (
      !user.admin &&
      !whatsappQrcode &&
      !whatsappApiMeta &&
      channelType === "WHATSAPP"
    ) {
      showSingleToast(
        "Você deve entrar em contato com o suporte para ativar o canal."
      );
      return;
    }

    if (!user.admin && !facebook && channelType === "FACEBOOK") {
      showSingleToast(
        "Você deve entrar em contato com o suporte para ativar o canal."
      );
      return;
    }

    if (!user.admin && !instagram && channelType === "INSTAGRAM") {
      showSingleToast(
        "Você deve entrar em contato com o suporte para ativar o canal."
      );
      return;
    }

    if (!user.admin && !whatsappQrcode && !whatsappApiMeta) return;
    if (channelType !== "WHATSAPP") return;

    setDisplayModal(true);
  };

  const handleModalClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  const handleTabChange = (e: any) => {
    const attemptedIndex = e.index;

    const valueWhatsappQrcode = attemptedIndex === 0;
    const valueWhatsappApiMeta = attemptedIndex === 1;

    const disabledWhatsappQrcode = !user.admin && !whatsappQrcode;
    const disabledWhatsappApiMeta = !user.admin && !whatsappApiMeta;

    if (
      (valueWhatsappQrcode && disabledWhatsappQrcode) ||
      (valueWhatsappApiMeta && disabledWhatsappApiMeta)
    ) {
      showSingleToast(
        "Você deve entrar em contato com o suporte para ativar o canal."
      );
      return;
    }

    setActiveIndex(attemptedIndex);
  };

  return (
    <div
      style={{
        opacity:
          channelType === "WHATSAPP"
            ? user.admin
              ? 1
              : whatsappQrcode || whatsappApiMeta
              ? 1
              : 0.4
            : 1
      }}
      onClick={handleShowWhatsappModal}
      className="whatsappCheck"
    >
      <div css={CheckCard} className="relative field-checkbox">
        {checked && (
          <IconButton>
            <img
              width="10px"
              onClick={(e) => {
                e.stopPropagation();
                handleCheckedIcon(channelType);
              }}
              src={BluePencil}
              alt="Edit Icon"
            />
          </IconButton>
        )}
        <img
          style={{ maxWidth: "1.875rem", maxHeight: "1.875rem" }}
          src={img}
          alt={`img-${name}`}
        />
        <Label htmlFor={name}>{name}</Label>
        <HiddenDiv>
          <Checkbox inputId={name} checked={checked} />
        </HiddenDiv>
      </div>
      <DialogPadrao
        displayDialog={displayModal}
        contentStyle={{ height: "420px" }}
        onHide={() => setDisplayModal(false)}
        headerStyle={{
          backgroundColor: user.plataform.mainColor || "#2624CD"
        }}
        onClick={handleModalClick}
      >
        <ContainerLeftModal tabColor={user.plataform.mainColor || "#2624CD"}>
          <TabView
            style={{ position: "sticky", top: 0 }}
            activeIndex={activeIndex}
            onTabChange={handleTabChange}
          >
            <TabPanel
              headerStyle={{ width: "100%" }}
              contentStyle={{
                border: 0,
                padding: 0,
                height: "100%"
              }}
              header="QRCode"
              // disabled={!user.admin && !whatsappQrcode}
              // headerTemplate={dialogTabTemplate}
            >
              <ContainerTab>
                {whatsappInstanceInfo?.qrCodeConnected ? (
                  <div className="flex flex-column gap-4 mt-6 w-full h-18rem">
                    <span className="p-float-label w-full">
                      <InputText
                        style={{ width: "100%" }}
                        id="in"
                        value={whatsappInstanceInfo?.name}
                        onChange={(e) => setValue(e.target.value)}
                      />
                      <label htmlFor="in">Responsável</label>
                    </span>
                    <div className="relative w-full">
                      <span className="p-float-label">
                        <InputText
                          style={{ width: "100%" }}
                          id="in"
                          value={whatsappInstanceInfo?.phone}
                        />
                        <label htmlFor="in">Telefone</label>
                        <PhoneConected>
                          <img src={whatsapp} alt="Whatsapp icon" />
                          <Text
                            s="1rem"
                            lh="1.5rem"
                            weight={400}
                            color="#02B960"
                          >
                            Ativo
                          </Text>
                        </PhoneConected>
                      </span>
                    </div>
                    <Switch>
                      <InputSwitch
                        checked={
                          whatsappInstanceInfo?.keepBotOnDialogInitiatedOnDevice
                        }
                        onChange={(e) => setValueSwitch(e.target.value)}
                      />
                      Manter o bot ativo em conversas iniciadas pelo dispositivo
                      móvel.
                    </Switch>
                    <div className="flex align-items-center justify-content-center w-full gap-3">
                      <Span>?</Span>
                      <Text
                        style={{ textAlign: "left" }}
                        color="#4C5862"
                        lh="1.3125rem"
                        s="0.875rem"
                      >
                        Lembre-se de usar o celular uma vez a cada{" "}
                        <Strong>14 dias</Strong> para ficar sempre conectado.
                      </Text>
                    </div>
                    <ContainerButtons>
                      <RemoverButton onClick={handleRemover}>
                        Remover
                      </RemoverButton>
                      <Button
                        label="Salvar"
                        style={{
                          width: "160px",
                          height: "42px",
                          borderColor: user.plataform.mainColor
                            ? user.plataform.mainColor
                            : "#2624CD",
                          background: user.plataform.mainColor
                            ? user.plataform.mainColor
                            : "#2624CD"
                        }}
                        onClick={handleUpdateChanges}
                      />
                    </ContainerButtons>
                  </div>
                ) : (
                  <>
                    <div className="flex gap-2">
                      <img src={WhatsIcon} alt="WhatsIcon" />
                      <div>
                        <Text
                          style={{ textAlign: "left" }}
                          weight={600}
                          lh="20px"
                          s="0.875rem"
                          color="#0A043C"
                        >
                          Todas as conversas em um único lugar!
                        </Text>
                        <Text
                          style={{ textAlign: "left" }}
                          weight={400}
                          lh="18px"
                          s="0.75rem"
                          color="#544F77"
                        >
                          Para integrar essa ferramenta incrível, basta conectar
                          o seu celular, vamos integrar todas as mensagens do
                          seu Bot em um único local.
                        </Text>
                      </div>
                    </div>
                    <div className="flex align-items-center justify-content-center">
                      {user.plataform.urlAvatar ? (
                        <img
                          src={user.plataform.urlAvatar}
                          alt="Robot Image"
                          style={{ width: "210px" }}
                        />
                      ) : (
                        <img
                          src={spaikIcon}
                          alt="Robot Image"
                          style={{ width: "210px" }}
                        />
                      )}
                    </div>
                  </>
                )}
              </ContainerTab>
            </TabPanel>
            <TabPanel
              headerStyle={{ width: "100%" }}
              contentStyle={{ padding: 0, height: "100%" }}
              header="Meta"
            >
              <ContainerTab>
                {name === "Chatbot" && <ChatbotScript botToken={botToken} />}
                {name === "WhatsApp" && (
                  <LeftContentWhatsappModal show={setDisplayModal} />
                )}
              </ContainerTab>
            </TabPanel>
          </TabView>
        </ContainerLeftModal>
        <ContainerRightModal
          style={{ backgroundColor: user.plataform.mainColor || "#2624CD" }}
        >
          {activeIndex === 1 ? (
            <>
              <div></div>
              {name === "Chatbot" ? (
                <RightContentChatBotModal />
              ) : (
                <RightContentWhatsappModal />
              )}
            </>
          ) : (
            <div className="flex flex-column align-items-center">
              <Text weight={600} color="#FFF">
                Leia o QRCode para atualizar o número do celular.
              </Text>
              <ContainerQRCode>
                {whatsappInstanceInfo?.phone ? (
                  <div className="flex flex-column align-items-center justify-content-center">
                    <img
                      style={{ maxWidth: "95%", maxHeight: "95%" }}
                      src={whatsappActive}
                      alt="Qr code example"
                    />
                  </div>
                ) : whatsappImage?.qrcode ? (
                  <img
                    src={whatsappImage?.qrcode}
                    alt="Qr code example"
                    css={css`
                      height: 100%;
                      width: 100%;
                    `}
                  />
                ) : (
                  <div className="flex flex-column align-items-center justify-content-center">
                    <ButtonReload
                      rotateIcon={rotateIconComponent}
                      onClick={handleRotateIcon}
                      src={Reload}
                      alt="reload-button"
                    />
                    <div
                      css={ButtonReloadDiv}
                      onClick={handleRotateIcon}
                      className="mt-2"
                    >
                      {rotateIconComponent
                        ? "Gerando QRCode"
                        : "Gerar QRCode..."}
                    </div>
                  </div>
                )}
              </ContainerQRCode>
              <Text weight={400} color="#FFF" lh="1.25rem">
                {whatsappInstanceInfo?.phone
                  ? `Agora você já pode receber mensagens diretamente do seu celular.`
                  : `O scanner do WhastApp está num lugar incomum! Para achá-lo, clique em Menu > Dispositivos conectados > Conectar um aparelho.`}
              </Text>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "5px",
                  marginTop: "10px"
                }}
              >
                <IoMdPlayCircle
                  style={{ marginLeft: "0.14rem" }}
                  size={25}
                  color="white"
                />
                <Text s="12px" weight={500} lh="16px" color="#FAFBFC">
                  Confira o vídeo
                </Text>
              </div>
            </div>
          )}
        </ContainerRightModal>
      </DialogPadrao>
      <Portal
        visible={true}
        element={
          removingWhatsapp ? (
            <div
              style={{
                position: "fixed",
                inset: 0,
                zIndex: 2147483647,
                background: "rgba(0,0,0,0.35)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
              }}
              // portal events still bubble through the React tree to the card's onClick
              onClick={(e) => e.stopPropagation()}
            >
              <ProgressSpinner
                style={{ width: "100px", height: "100px" }}
                strokeWidth="4"
                fill="var(--surface-ground)"
                animationDuration=".6s"
              />
            </div>
          ) : null
        }
      />
    </div>
  );
};
